// @mui
import {
  Card,
  Stack,
} from '@mui/material';
// sections
import {
  TodoList,
  DoneList,
} from './';


export default function TodoDoneCard({ companyId, todos, dones, isActive, isValidating }) {

  return (
    <Stack spacing={2}>
      <Card>
        <TodoList companyId={companyId} todos={todos} isActive={isActive} isValidating={isValidating} />
      </Card>
      <Card>
        <DoneList companyId={companyId} dones={dones} isActive={isActive} isValidating={isValidating} />
      </Card>
    </Stack>
  )

}
